export default {
  name: 'es-mycard-sub-menu',
  data: () => ({
    scrollY: 0,
    badgeCount: 0,
    currentRouteName: ''
  }),
  watch: {
    '$route': {
      handle (route) {
        this.currentRouteName = route.name
      },
      deep: true
    }
  },
  computed: {
    subMenuPositionFixed () {
      return this.scrollY > 59
    },
    // set pictures
    pictureIndex () {
      if (this.selectedIndex) {
        return require('../images/icon_people_gold.png')
      }
      return require('../images/icon_people_gray.png')
    },
    pictureUser () {
      if (localStorage.profile_image_path) {
        return localStorage.profile_image_path + '?token=' + localStorage.access_token + '&timestamp=' + this.timeStamp
      } else {
        return require('../images/icon_submenu_face.png')
      }
    },
    pictureStar () {
      if (this.selectedStar) {
        return require('../images/icon_star_gold.png')
      }
      return require('../images/icon_star_gray.png')
    },
    picturePencil () {
      if (this.selectedPencil) {
        return require('../images/icon_pencil_gold.png')
      }
      return require('../images/icon_pencil_gray.png')
    },
    picturePhoto () {
      if (this.selectedPhoto) {
        return require('../images/icon_camera_plus_gold.png')
      }
      return require('../images/icon_camera_plus_gray.png')
    },
    // get selected state
    selectedIndex () {
      return this.currentRouteName === 'EsMyCardList'
    },
    selectedUser () {
      return this.currentRouteName === 'EsMyCardMyList'
    },
    selectedStar () {
      return this.currentRouteName === 'EsMyCardFavoriteList'
    },
    selectedPencil () {
      return this.currentRouteName === 'EsMyCardSelectDesign'
    },
    selectedPhoto () {
      return this.currentRouteName === 'FacingTypeCardExchangeSelect'
    },
    timeStamp () {
      var d = new Date()
      var year = d.getFullYear()
      var month = d.getMonth() + 1
      var day = d.getDate()
      var hour = (d.getHours() < 10) ? '0' + d.getHours() : d.getHours()
      var min = (d.getMinutes() < 10) ? '0' + d.getMinutes() : d.getMinutes()
      var sec = (d.getSeconds() < 10) ? '0' + d.getSeconds() : d.getSeconds()
      return year + '' + month + '' + day + '' + hour + '' + min + '' + sec
    }
  },
  created () {
    this.currentRouteName = this.$route.name
    this.getNotAlreadyReadCount()
  },
  mounted () {
    window.addEventListener('scroll', this.handleScroll)
  },
  beforeDestroy () {
    window.removeEventListener('scroll', this.handleScroll)
  },
  methods: {
    handleScroll () {
      this.scrollY = window.scrollY
    },
    async getNotAlreadyReadCount () {
      let data = {
        user_id: localStorage.user_id
      }

      let res = await this.$store.dispatch('CARD_NOT_ALREADY_READ_COUNT', { data: data })
      .catch(err => {
        console.log(err)
        return
      })
      this.badgeCount = res.count
    },
    goMyCardList () {
      const userId = window.localStorage.getItem('user_id')
      this.$router.push({
        path: `/es_mycard_list/${userId}`,
        query: { 'target': this.targetUser }
      })
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/scripts/es-mycard-sub-menu.js